import { computed } from 'vue';
import { ModalCustomProductStates } from '@/models/modal/modal.enum';
import { Currency, CustomProductDto } from '@studyportals/campaign-management-api-interface';
import { IUnsavedCustomProductData } from '@/models/custom-products.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import datePresenter from'@/presenters/date-presenter';
import customBudgetPresenter from '@/presenters/custom-budget-presenter';
import customProductPresenter from '@/presenters/custom-product-presenter';
import store from '@/store';

export default class TableAddedProductsCode {

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusCustomProducts();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public idsOfModifiedCustomProducts = computed((): (number | string)[] => {
		return store.getters.idsOfModifiedCustomProducts();
	});

	public customProducts = computed((): (IUnsavedCustomProductData | CustomProductDto)[] => {
		return store.getters.customProducts();
	});

	public selectedTableActionsDropdown = computed((): number => {
		return store.getters.selectedTableActionsDropdown();
	});

	private currency = computed((): Currency | null => {
		return store.getters.currency();
	});

	public retrieveDateStringForCustomProduct(customProduct: IUnsavedCustomProductData | CustomProductDto): string {
		return datePresenter.transformDateObjectToUTCDateString(customProduct.date, false);
	}

	public retrievePriceForCustomProduct(customProduct: IUnsavedCustomProductData | CustomProductDto): string {
		if (!this.currency.value) {
			return '';
		}

		const priceFormatted = customBudgetPresenter.formatNumber(customProduct.price);
		return `${priceFormatted} ${this.currency.value}`;
	}

	public retrieveTypeForCustomProduct(customProduct: IUnsavedCustomProductData | CustomProductDto): string {
		return customProductPresenter.retrieveLabelOfType(customProduct.productType);
	}

	public onDropdownTriggerClicked(index: number): void {
		const newIndex = this.selectedTableActionsDropdown.value === index ? -1 : index;
		store.mutations.setSelectedTableActionsDropdown(newIndex);
	}

	public onEditClicked(customProduct: IUnsavedCustomProductData | CustomProductDto): void {
		store.mutations.setSelectedCustomProductId(customProduct.id);
		store.mutations.setModalCustomProductState(ModalCustomProductStates.EDIT_PRODUCT);
	}

	public onDuplicateClicked(customProduct: IUnsavedCustomProductData | CustomProductDto): void {
		store.mutations.addCustomProduct({
			id: customProductPresenter.newCustomProductLabel.value,
			productType: customProduct.productType,
			name: customProduct.name,
			description: customProduct.description,
			price: customProduct.price,
			date: customProduct.date
		});

		store.mutations.setSelectedTableActionsDropdown(-1);
	}

	public onDeleteClicked(customProduct: IUnsavedCustomProductData | CustomProductDto): void {
		store.mutations.setSelectedCustomProductId(customProduct.id);
		store.mutations.setModalCustomProductState(ModalCustomProductStates.DELETE_PRODUCT);
	}
}
